// Package Imports
import { toJS } from "mobx";
import moment from "moment";

// Project Imports
import axios from "utils/axios";
import * as APITypes from 'constants/API';
import isObjectEmpty from "utils/isObjectEmpty";
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import createNewObject from "utils/createNewObject";
import generateRandomString from "utils/generateRandomString";
import FamilyMemberFieldStructureObject from "./FamilyMemberFieldStructureObject";
import FamilyDetailsStore from "../store/FamilyDetailsStore";
import FamilyMemberTypeEnum from "../FamilymemberTypeEnum";
import FamilyMemberList from "./familyMembersList";
import FieldTypeEnum from "./FieldTypsEnum";
import familyMemberList from "./familyMembersList";
import capitalizeFirstLetter from "utils/capitalizeFirstLetter";
import AuthStore from "modules/login/store/AuthStore";
import fetchDeselectedExpenses from "utils/fetchDeselectedExpenses";
import addFamilyMemberFromUtils from "utils/addFamilyMember";
import genderTypeEnum from "constants/genderTypeEnum";
import genderValueEnum from "constants/genderValueEnum";
import fetchDeselectedExpensesForEmi from "utils/fetchDeselectedExpensesForEmi";
import journeyTypeEnum from "constants/journeyTypeEnum";
import nationalityEnum from "constants/nationalityEnum";
import { MWP_ACT } from "constants/ CustomerType";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { BANCA_JOURNEY, ACCEPT_NATIONALITY,COOKIE_PARA_NAME_FOR_JOURNEY_ID, disabledProposerFieldBanca } from "../../../constants/Constants";
import getCookieValue from "utils/getCookieValue/getCookieValue";

const checkIfFamilyMemberAreAdded = (membersList) => {

    let defaultSelectedOptionKeys = ["salutation", 'nationality', 'is_selected', 'family_member_type', 'gender', 'current_life_cover', 'monthly_income_dropdown_option', 'monthly_income_value', 'life_assured', 'proposer', 'is_member_selected', 'secondary_la', 'payment_option']
    let selectedMemberList = [];

    for (const member in membersList) {

        for (const memberField in membersList[member]) {
            if (defaultSelectedOptionKeys.includes(memberField)) {
                continue
            }

            if (!checkIsValueEmpty(membersList[member][memberField])) {
                selectedMemberList.push(member)
                break;
            }
        }
    }

    selectedMemberList.push("self")

    return selectedMemberList
}

export const fetchSelectedMembers = (membersList, formController) => {

    let selectedMemberList = checkIfFamilyMemberAreAdded(membersList, formController)
    for (let member in membersList) {
        let isSelected = false
        if (selectedMemberList.includes(member)) {
            isSelected = true
        }
        formController.$("members").$(member).extra.isSelected = isSelected
    }

    return selectedMemberList
}

const closeModal = (hideModal, formController) => {
    let show_member_type = !isObjectEmpty(formController.$("show_member_type").value) ? formController.$("show_member_type").value : { id: "OTHER", label: "other" }
    let updatedfamilyDetailsList = checkMemberTypeEmpty(toJS(AuthStore.journeyData.family_details_list), show_member_type.id)
    let journeyData = toJS(AuthStore.journeyData)
    journeyData["family_details_list"] = updatedfamilyDetailsList
    reInitializeFamilyMemberData(journeyData, formController)

    if (show_member_type.id !== "OTHER") {
        formController.$("members").$(show_member_type?.id.toLowerCase()).$('member_type_list').set("value", show_member_type)
    }
    let MemberTypeEmpty = AuthStore?.journeyData?.family_details_list.some(item => item?.family_member_type === null)
    if (MemberTypeEmpty) {
        formController.$("members").$(show_member_type?.id.toLowerCase()).$('life_assured').set("value", true)
        formController.$("members").$("self").$('proposer').set("value", true)
    }

    formController.$("show_member_type").set("value", show_member_type)
    hideModal()
}

export const reInitializeFamilyMemberData = (journeyData, formController) => {

    let lifeCoverList = FamilyDetailsStore.lifeCoverList
    let nationalMasterList = FamilyDetailsStore.nationalityList
    let salutationMasterList = FamilyDetailsStore.salutationList
    let monthlyIncomeMasterList = FamilyDetailsStore.monthlyIncomelist

    let selfDetails = formController.$('members').$('self').get()
    let details = Object.entries(formController.$("members").get())

    let selfDetailsObj = {}

    for (let key in selfDetails) {
        selfDetailsObj[key] = selfDetails[key].value
    }
    const memberDetails = details.filter((item) => item[1].extra.isSelected)

    let familyFieldList = preFillUserFields(journeyData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, memberDetails)

    familyFieldList[0].fields.forEach((item) => {

        const { name, value } = item

        if (!item.hasOwnProperty('value') || checkIsValueEmpty(value)) {
            item.value = selfDetailsObj[name]
        }
    })

    formController.$("members").del()

    formController.add(
        {
            name: "members",
            fields: familyFieldList
        }
    )
}

const addFamilyMember = async (formController, hideModal) => {

    addFamilyMemberFromUtils(
        formController,
        fetchSelectedMembers,
        submitDataToTheServer,
        AuthStore,
        reInitializeFamilyMemberData,
        hideModal
    )
}


const removeEmptyObject = (objectData) => {
    let itemdata = []
    for (const item in objectData) {
        if (!isObjectEmpty(objectData[item])) {
            itemdata.push(objectData[item])
        }
    }
    return createNewObject(itemdata)
}

const sendDataToServer = async (formController) => {
    let { isValid } = await formController.validate({ showErrors: true })

    if (isValid) {
        let { members, liabilities, monthly_expense, savings, monthly_emi } = formController.values()

        let selectedMonthlyExpense = removeEmptyObject(monthly_expense)
        let monthlyEmi = removeEmptyObject(monthly_emi)
        let selectedLiabilities = removeEmptyObject(liabilities)
        let selectedSavings = removeEmptyObject(savings)

        let expenseList = [
            ...selectedMonthlyExpense,
            ...selectedLiabilities,
            ...selectedSavings,
        ]

        let emiList = [];
        let monthlyEmiObject = { ...monthlyEmi };
        for (const selectedKey in monthlyEmiObject) {
            let objPrefix = monthlyEmiObject[selectedKey];
            let isDisabled = isObjectEmpty(monthlyEmiObject[selectedKey].option_range)

            if (!isDisabled) {
                emiList.push({
                    action: "save",
                    id: objPrefix.option_range.id,
                    expense_range_id: objPrefix.option_range.id,
                    expense_range_key: objPrefix.option_range.label,
                    expense_range_value: objPrefix.option_range.label,
                    paid_years: objPrefix.paid_years.value,
                    total_years: objPrefix.total_years.value,
                    user_journey: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
                });
            }
        }

        expenseList.map((item) => {
            item.action = 'save';
            item.expense_range_id = item.id
            item.expense_range_key = item.label
            item.expense_range_value = item.value
            return item
        })

        const selectedMemberList = fetchSelectedMembers(members, formController)

        let values = formController.values();

        let data = []
        let familyMembersList = values.members

        for (const memberData in familyMembersList) {

            if (selectedMemberList.includes(memberData)) {
                data.push(familyMembersList[memberData])
            }
        }

        data.map(item => {

            if (!checkIsValueEmpty(item.salutation)) {
                item.salutation = item.salutation.id
            }

            if (!checkIsValueEmpty(item.nationality)) {
                item.nationality = item.nationality.id
            }

            if (!checkIsValueEmpty(item.payment_option)) {
                item.payment_option = item.payment_option?.id
            } else {
                item.payment_option = ''
            }

            if (!checkIsValueEmpty(item.monthly_income_dropdown_option)) {
                item.monthly_income_dropdown_option = item.monthly_income_dropdown_option.id
            }
            if (!checkIsValueEmpty(item.dob)) {
                if (!moment(item.dob, 'DD-MM-YYYY', true).isValid()) {
                    item.dob = moment(item.dob).format('YYYY-MM-DD')
                } else {
                    item.dob = moment(item.dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
                }
            }

            if (!checkIsValueEmpty(item.current_life_cover)) {
                item.current_life_cover = item.current_life_cover.id
            }

            if (!isObjectEmpty(item.gender)) {
                item.gender = item.gender.value
            }

            item.monthly_income = item.monthly_income_value
            item.is_selected = true

            item.first_name = capitalizeFirstLetter(item.first_name)
            item.middle_name = capitalizeFirstLetter(item.middle_name)
            item.last_name = capitalizeFirstLetter(item.last_name)

            for (const [key, value] of Object.entries(item)) {
                if (typeof (value) === 'string') {
                    if (value === '') {
                        delete item[key]
                    }

                }

                if (typeof (value) === 'object') {
                    if (isObjectEmpty(value)) {
                        delete item[key]
                    }
                }
            }

            return item
        })

        let journeyData = toJS(AuthStore.journeyData);
        let productDetailsList = journeyData.family_product_details_list.filter((item) => item.is_selected) // need to filter first selected needs

        let details = {}
        let termNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 4)
        let gmmNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 1)
        let childNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 2)
        let retirementNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 3)
        let healthNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 5)

        if (Object.keys(details).length === 0 && termNeedData) { details = termNeedData }
        if (Object.keys(details).length === 0 && gmmNeedData) { details = gmmNeedData }
        if (Object.keys(details).length === 0 && childNeedData) { details = childNeedData }
        if (Object.keys(details).length === 0 && retirementNeedData) { details = retirementNeedData }
        if (Object.keys(details).length === 0 && healthNeedData) { details = healthNeedData }

        if (journeyData.family_details_list.length !== 1 && journeyData?.family_details_list[0].family_member_type === "SELF") {

            // Change LA API
            let selectedLaDetails = data.find((item) => item.life_assured)

            if (details.family !== selectedLaDetails?.id) {
                let changeLaRequest = []
                productDetailsList.forEach((item) => {
                    changeLaRequest.push({
                        dob: selectedLaDetails.dob,
                        monthly_income: selectedLaDetails.monthly_income || selectedLaDetails.monthly_income_dropdown_option,
                        family_member_id: selectedLaDetails.id,
                        family_product_id: item.id,
                        need: item.need,
                        is_selected: item.is_selected,
                        target_amount_value: item.target_amount_value,
                        target_amount: item.target_amount,
                        payout_mode: item.payout_mode
                    })
                })
                await axios.post(
                    APITypes.CHANGE_LA_ALL_NEEDS,
                    changeLaRequest
                )
            }

            // Change PR API
            let selectedPrDetails = data.find((item) => item.proposer)
            if (details.proposer_family !== selectedPrDetails.id) {
                let changePrRequest = {}
                productDetailsList.forEach((item) => {
                    changePrRequest = {
                        journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
                        proposer_id: selectedPrDetails.id,
                        family_product_id: item.id,
                        need: item.need,
                    }
                })
                await axios.post(
                    APITypes.CHANGE_PR_ALL_NEEDS,
                    changePrRequest
                )
            }
            // !CHANGE_SECONDARY_LA_ALL_NEEDS API
            let selectedSecondaryLaDetails = data.find((item) => item.secondary_la)
            // if (details.family !== selectedSecondaryLaDetails?.id) {
            let secondaryLaSelected = selectedSecondaryLaDetails?.id ? true : false
            let changeSecondaryLaRequest = []
            if (secondaryLaSelected) {
                productDetailsList.forEach((item) => {
                    if(item.need != 4){
                        changeSecondaryLaRequest.push({
                            dob: selectedSecondaryLaDetails.dob,
                            monthly_income: selectedSecondaryLaDetails.monthly_income || selectedSecondaryLaDetails.monthly_income_dropdown_option,
                            secondary_la_id: selectedSecondaryLaDetails.id,
                            family_product_id: item.id,
                            need: item.need,
                            is_selected: item.is_selected,
                            target_amount_value: item.target_amount_value,
                            target_amount: item.target_amount,
                            payout_mode: item.payout_mode
                        })
                    }
                })
            }
            await axios.post(
                APITypes.CHANGE_SECONDARY_LA_ALL_NEEDS, {
                secondary_la_selected: secondaryLaSelected,
                list: changeSecondaryLaRequest,
                journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
            }

            )
            //  }

        }

        await submitDataToTheServer(formController, selectedMemberList, expenseList, emiList)

        global.loading(false);

    } else {
        console.log("Error are ", formController.errors())
    }
}


const createFamilyMemberFieldData = (lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductData, memberDetails) => {

    let memberFieldsList = []

    let isProtectionNeedSelected = checkIsProtectionNeedSelected(familyProductData)

    FamilyMemberList.forEach((item) => {
        let memberFieldObject = generateMemberEmptyDataStrucutre(item, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected, memberDetails)
        memberFieldsList.push(memberFieldObject)
    })

    return memberFieldsList

}

export const submitDataToTheServer = async (formController, selectedMemberList, expenseList = [], emiList = []) => {

    global.loading(true);

    let values = formController.values();

    let data = []
    let familyMembersList = values.members
    let isExistingMember = checkExistingCustomerdetails(formController)
    for (const memberData in familyMembersList) {

        if (selectedMemberList.includes(memberData)) {
            data.push(familyMembersList[memberData])
        }
    }

    data.map(item => {

        if (!checkIsValueEmpty(item.salutation)) {
            item.salutation = item.salutation.id
        }

        if (!checkIsValueEmpty(item.nationality)) {
            item.nationality = item.nationality.id
        }
     
        if (!checkIsValueEmpty(item.payment_option)) {
            item.payment_option = item.payment_option?.id
        } else {
            item.payment_option = ''
        }

        if (!checkIsValueEmpty(item.monthly_income_dropdown_option)) {
            item.monthly_income_dropdown_option = item.monthly_income_dropdown_option.id
        }
        if (!checkIsValueEmpty(item.dob)) {
            if (!moment(item.dob, 'DD-MM-YYYY', true).isValid()) {
                item.dob = moment(item.dob).format('YYYY-MM-DD')
            } else {
                item.dob = moment(item.dob, 'DD-MM-YYYY').format('YYYY-MM-DD')
            }
        }

        if (!checkIsValueEmpty(item.current_life_cover)) {
            item.current_life_cover = item.current_life_cover.id
        }

        if (!isObjectEmpty(item.gender)) {
            item.gender = item.gender.value
        }

        item.monthly_income = item.monthly_income_value
        item.is_selected = true

        item.first_name = capitalizeFirstLetter(item.first_name)
        item.middle_name = capitalizeFirstLetter(item.middle_name)
        item.last_name = capitalizeFirstLetter(item.last_name)

        for (const [key, value] of Object.entries(item)) {
            if (typeof (value) === 'string') {
                if (value === '') {
                    delete item[key]
                }

            }

            if (typeof (value) === 'object') {
                if (isObjectEmpty(value)) {
                    delete item[key]
                }
            }
        }

        return item
    })

    let monthleExpenseDeSelectedList = fetchDeselectedExpenses(formController, 'monthly_expense')
    let monthleSavingsDeSelectedList = fetchDeselectedExpenses(formController, 'liabilities')
    let currentSavingsDeSelectedList = fetchDeselectedExpenses(formController, 'savings')
    let emiDeSelectedList = fetchDeselectedExpensesForEmi(formController, 'monthly_emi')

    let deSelectedExpenseList = [
        ...monthleExpenseDeSelectedList,
        ...monthleSavingsDeSelectedList,
        ...currentSavingsDeSelectedList
    ]

    let deselectExpensesData = deSelectedExpenseList.map(item => item.journeyExpenseId)
    let selfData = data.find((item) => item.family_member_type === FamilyMemberTypeEnum.SELF)
    if (deselectExpensesData.length > 0) {
        await axios.post(
            APITypes.DESELECT_EXPENSE,
            {
                "family_member_id": selfData.id,
                "id": deselectExpensesData
            }
        )
    }

    if (emiDeSelectedList.length > 0) {
        await axios.post(
            APITypes.DESELECT_EMI,
            {
                "family_member_id": selfData.id.toString(),
                "id": emiDeSelectedList
            }
        )
    }


    let response = await axios.post(
        APITypes.SAVE_FAMILY_DETAILS,
        data = {
            journey_id: values.journey_id,
            family_list: data,
            expense_list: expenseList,
            emi_list: emiList,
            isExistingCustomer: isExistingMember
        }
    )
    // await AuthStore.fetchAllData(values.journey_id)

    return response;
}


const setFamilyMemberFieldValue = (fieldList, fieldName, fieldApiValue, fieldType = FieldTypeEnum.NORMAL) => {

    if (fieldApiValue == null) return

    switch (fieldType) {
        case FieldTypeEnum.GENDER_DROPDOWN:
            setDropDownOptionsListValue(fieldList, fieldName, fieldApiValue)
            break

        case FieldTypeEnum.MASTER_DATA:
            setMasterFieldValue(fieldList, fieldName, fieldApiValue)
            break

        default:
            fieldList.find(fieldObj => fieldObj.name == fieldName).value = fieldApiValue
            break
    }

}

const setMasterFieldValue = (fieldList, fieldName, fieldApiValue) => {
    let field = fieldList.find(fieldObj => fieldObj.name == fieldName)
    let selectedFieldValue = field.extra.optionList.find(fieldData => fieldData.id == fieldApiValue)
    if (selectedFieldValue !== undefined) {
        field.value = selectedFieldValue
    }
}

const setDropDownOptionsListValue = (fieldList, fieldName, fieldApiValue) => {
    let field = fieldList.find(fieldObj => fieldObj.name == fieldName)
    let selectedFieldValue = field.extra.optionList.find(fieldData => fieldData.value.toLowerCase() == fieldApiValue.toLowerCase())
    if (selectedFieldValue !== undefined) {
        field.value = selectedFieldValue
    }
}

const setIndividualFieldValue = (familyMemberApiData, field) => {
    setFamilyMemberFieldValue(field, 'id', familyMemberApiData.id)
    setFamilyMemberFieldValue(field, 'first_name', familyMemberApiData.first_name)
    setFamilyMemberFieldValue(field, 'middle_name', familyMemberApiData.middle_name)
    setFamilyMemberFieldValue(field, 'last_name', familyMemberApiData.last_name)
    setFamilyMemberFieldValue(field, 'dob', familyMemberApiData.dob)
    setFamilyMemberFieldValue(field, 'monthly_income_value', familyMemberApiData.monthly_income)
    setFamilyMemberFieldValue(field, 'gender', familyMemberApiData.gender, FieldTypeEnum.GENDER_DROPDOWN)
    setFamilyMemberFieldValue(field, 'nationality', familyMemberApiData.nationality, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'current_life_cover', familyMemberApiData.current_life_cover, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'salutation', familyMemberApiData.salutation, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'monthly_income_dropdown_option', familyMemberApiData.monthly_income_dropdown_option, FieldTypeEnum.MASTER_DATA)
    setFamilyMemberFieldValue(field, 'is_member_selected', familyMemberApiData.is_member_selected)
    setFamilyMemberFieldValue(field, 'secondary_la', familyMemberApiData.secondary_la)
    setFamilyMemberFieldValue(field, 'payment_option', familyMemberApiData?.payment_option, FieldTypeEnum.MASTER_DATA)

    // if (familyMemberApiData.monthly_income !== null) {
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_value').type = 'text'
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_dropdown_option').type = 'hidden'
    // } else {
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_dropdown_option').type = 'text'
    //     field.find(fieldObj => fieldObj.name == 'monthly_income_value').type = 'hidden'
    // }
}

const checkIsProtectionNeedSelected = (familyProductDataList) => {
    let isProtectionNeedSelected = familyProductDataList?.some(
        (item) => {

            if (item.is_selected) {
                return item.need_unique_name === 'protection_for_my_family' || item.need_unique_name === 'protection_for_my_health'
            }

            return false
        })

    return isProtectionNeedSelected
}

const checkIsNotProtectionNeedSelected = (familyProductDataList) => {

    let isProtectionNeedSelected = familyProductDataList?.some(
        (item) => {
            if (item.is_selected) {
                return item.need_unique_name === 'grow_my_money' || item.need_unique_name === 'save_for_children' || item.need_unique_name === 'save_for_retirement'
            }
            return false
        })
    return isProtectionNeedSelected
}



const preFillFamilyDetails = (memberFieldObjectList, familyMemberList, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductDataList) => {
    let selfDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.SELF);
    let spouseDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.SPOUSE);
    let childDetailsList = familyMemberList?.filter(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.CHILD);
    let adultChildDetailsList = familyMemberList?.filter(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.ADULT_CHILD);
    let grandChildDetailsList = familyMemberList?.filter(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.GRAND_CHILD);
    let grandFatherDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.GRAND_FATHER);
    let grandMotherDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === FamilyMemberTypeEnum.GRAND_MOTHER);
    let otherDetails = familyMemberList?.find(member => member.family_member_type.toUpperCase() === "OTHER");


    let isProtectionNeedSelected = checkIsProtectionNeedSelected(familyProductDataList)

    if (childDetailsList?.length > 1) {
        let childData = FamilyMemberList?.find((member) => member.memberType === FamilyMemberTypeEnum.CHILD)
        for (let i = 0; i < childDetailsList.length - 1; i++) {
            let childMemberFieldObjectData = generateMemberEmptyDataStrucutre(childData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected)
            childMemberFieldObjectData.name = childMemberFieldObjectData.name + (i + 1)
            memberFieldObjectList.push(childMemberFieldObjectData)
        }
    }

    if (adultChildDetailsList?.length > 1) {
        let adultChildData = FamilyMemberList.find((member) => member.memberType === FamilyMemberTypeEnum.ADULT_CHILD)
        for (let i = 0; i < childDetailsList.length - 1; i++) {
            let childMemberFieldObjectData = generateMemberEmptyDataStrucutre(adultChildData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected)
            childMemberFieldObjectData.name = childMemberFieldObjectData.name + (i + 1)
            memberFieldObjectList.push(childMemberFieldObjectData)
        }
    }

    if (grandChildDetailsList?.length > 1) {
        let grandChildData = FamilyMemberList.find((member) => member.memberType === FamilyMemberTypeEnum.GRAND_CHILD)
        for (let i = 0; i < grandChildDetailsList.length - 1; i++) {
            let childMemberFieldObjectData = generateMemberEmptyDataStrucutre(grandChildData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected)
            childMemberFieldObjectData.name = childMemberFieldObjectData.name + (i + 1)
            memberFieldObjectList.push(childMemberFieldObjectData)
        }
    }

    memberFieldObjectList.map(item => {

        if (item.name.toUpperCase() === FamilyMemberTypeEnum.SELF) {
            if (selfDetails !== undefined) {
                setIndividualFieldValue(selfDetails, item.fields)
            }
        }
        if (item.name.toUpperCase() === "OTHER") {
            if (otherDetails !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(otherDetails, item.fields)
            }
        }

        if (item.name.toUpperCase() === FamilyMemberTypeEnum.SPOUSE) {
            if (spouseDetails !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(spouseDetails, item.fields)
            }
        }

        if (item.name.toUpperCase().startsWith(FamilyMemberTypeEnum.CHILD)) {
            var currentChildElement = childDetailsList?.shift();
            if (currentChildElement !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(currentChildElement, item.fields)
            }
        }

        if (item.name.toUpperCase().startsWith(FamilyMemberTypeEnum.ADULT_CHILD)) {
            var currentChildElement = adultChildDetailsList?.shift();
            if (currentChildElement !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(currentChildElement, item.fields)
            }
        }

        if (item.name.toUpperCase().startsWith(FamilyMemberTypeEnum.GRAND_CHILD)) {
            var currentChildElement = grandChildDetailsList?.shift();
            if (currentChildElement !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(currentChildElement, item.fields)
            }
        }

        if (item.name.toUpperCase() === FamilyMemberTypeEnum.GRAND_FATHER) {
            if (grandFatherDetails !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(grandFatherDetails, item.fields)
            }
        }

        if (item.name.toUpperCase() === FamilyMemberTypeEnum.GRAND_MOTHER) {
            if (grandMotherDetails !== undefined) {
                item.extra.isSelected = true
                setIndividualFieldValue(grandMotherDetails, item.fields)
            }
        }

        return item
    })
}


const preFillUserFields = (journeyData, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, memberDetails) => {

    let familyDetailsList = journeyData.family_details_list

    let familyProductData = journeyData.family_product_details_list

    let familyFieldList = createFamilyMemberFieldData(lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, familyProductData, memberDetails)

    preFillFamilyDetails(
        familyFieldList,
        familyDetailsList,
        lifeCoverList,
        nationalMasterList,
        salutationMasterList,
        monthlyIncomeMasterList,
        familyProductData
    )

    return familyFieldList

}

const toggleDisableOptions = (formController, sectionName, fieldName, isDisabled) => {
    formController.$(sectionName).$(fieldName).set('disabled', isDisabled)
    if (formController.$(sectionName).$(fieldName).disabled) {
        formController.$(sectionName).$(fieldName).value = {}
        formController.$(sectionName).$(fieldName).resetValidation();
    }
}

const changeFieldValue = (formController, sectionName, fieldName, value) => {

    formController.$(sectionName).$(fieldName).value = value
    if (!checkIsValueEmpty(value)) {
        formController.$(sectionName).$(fieldName).resetValidation();
    }
}

const generateMemberEmptyDataStrucutre = (familyObj, lifeCoverList, nationalMasterList, salutationMasterList, monthlyIncomeMasterList, isProtectionNeedSelected, memberDetailsList) => {
    let memberFieldObject = createNewObject(FamilyMemberFieldStructureObject)

    let journeyData = toJS(AuthStore.journeyData);
    let journeyList = toJS(AuthStore.journeyList)
    let source_system = getCookieValue("source")

    const selfJourneyTypeValue = journeyData.journey_details.journey_type
    const selfJourneyTypeOption = journeyList.find(singleJourney => singleJourney.id == selfJourneyTypeValue).label

    let selectedNation = {}

    const nationalityObj = {}
    nationalMasterList.forEach((item) => {
        nationalityObj[item.label] = item
    })

    let memberDetails = {}
    if (memberDetailsList && memberDetailsList.length > 0) {
        memberDetailsList.forEach((item) => {
            if (item[0] === familyObj.name) {
                memberDetails = item[1]
            }
        })
    }

    (memberDetailsList && memberDetails.length > 2) ? memberDetailsList[familyObj.name] : {}
    switch (selfJourneyTypeOption) {
        case journeyTypeEnum.INDIVIDUAL_AND_FAMILY:
        case MWP_ACT:
            selectedNation = nationalityObj[nationalityEnum.INDIAN]
            break;

        case journeyTypeEnum.NRI:
            selectedNation = nationalityObj[nationalityEnum.NRI]
            break;

        case journeyTypeEnum.FOREIGN_NATIONAL:
            selectedNation = nationalityObj[nationalityEnum.FOREIGN_NATIONAL]
            break;

        case journeyTypeEnum.FNIO_PIO:
            selectedNation = nationalityObj[nationalityEnum.FNIO_PIO]
            break;

        case journeyTypeEnum.OTHERS:
            selectedNation = nationalityObj[nationalityEnum.OTHERS]
            break;

        default:
            break;
    }

    memberFieldObject.name = familyObj.name
    memberFieldObject.label = familyObj.label
    memberFieldObject.extra.isSelected = familyObj.defaultSelected
    memberFieldObject.fields.find(formField => formField.name === 'family_member_type').value = familyObj.memberType

    // set nationality master option list
    memberFieldObject.fields.find(formField => formField.name === 'nationality').extra.optionList = nationalMasterList
    memberFieldObject.fields.find(formField => formField.name === 'nationality').value = selectedNation

    // set life cover master option list
    memberFieldObject.fields.find(formField => formField.name === 'current_life_cover').extra.optionList = lifeCoverList

    // setting default value of cover to No cover
    memberFieldObject.fields.find(formField => formField.name === 'current_life_cover').value = lifeCoverList[0]

    // set Monthly Income Dropdown list
    memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').extra.optionList = monthlyIncomeMasterList
    // memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').value = monthlyIncomeMasterList[0]

    // set salutation master option list
    memberFieldObject.fields.find(formField => formField.name === 'salutation').extra.optionList = salutationMasterList
    memberFieldObject.fields.find(formField => formField.name === 'salutation').value = salutationMasterList[0]

    // set LA and PR
    memberFieldObject.fields.find(formField => formField.name === 'life_assured').value = memberDetails?.value?.life_assured || false;

    memberFieldObject.fields.find(formField => formField.name === 'proposer').value = memberDetails?.value?.proposer || false;

    // set the default salution for spouse and grandmother
    if (familyObj.memberType === FamilyMemberTypeEnum.SPOUSE || familyObj.memberType === FamilyMemberTypeEnum.GRAND_MOTHER) {
        memberFieldObject.fields.find(formField => formField.name === 'salutation').value = salutationMasterList[2]
    }

    // disbaled nationality dropdown for self
    if (familyObj.memberType === FamilyMemberTypeEnum.SELF) {
        memberFieldObject.fields.find(formField => formField.name === 'nationality').disabled = true;
    }

    if (isProtectionNeedSelected) {
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').type = "text"
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').type = "hidden"
    } else {
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').type = "hidden"
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').type = "text"
    }

    // Hide Monthly income ,Life assured & Proposer for Child & Grannd Child
    if (familyObj.memberType === FamilyMemberTypeEnum.CHILD || familyObj.memberType === FamilyMemberTypeEnum.GRAND_CHILD) {
        // memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').extra.visible = false
        // memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').extra.visible = false

        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').disabled = true;
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_value').value = 'No Income'

        if (isProtectionNeedSelected) {
            memberFieldObject.fields.find(formField => formField.name === 'life_assured').disabled = true;
            memberFieldObject.fields.find(formField => formField.name === 'proposer').disabled = true;
        } else {
            memberFieldObject.fields.find(formField => formField.name === 'proposer').disabled = true;
        }

        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').disabled = true;
        memberFieldObject.fields.find(formField => formField.name === 'monthly_income_dropdown_option').value = monthlyIncomeMasterList[0]


        // Setting maximum 18 years of age in the calendar
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.maxDate = moment().subtract(25, 'years')
        memberFieldObject.fields.find(formField => formField.name === 'dob').extra.minDate = ""
    }

    if (source_system == BANCA_JOURNEY) {
        memberFieldObject.fields.find(formField => formField.name === 'proposer').disabled = true;
        if (memberDetails?.value?.proposer) {
            disabledProposerFieldBanca.forEach(fieldName => {
                memberFieldObject.fields.find(formField => formField.name === fieldName).disabled = true;
            });
        }
    }

    // Set Default gender based on the structure defined in the family member list
    if (familyObj.gender !== undefined) {
        const genderField = memberFieldObject.fields.find(formField => formField.name === 'gender')
        const selectedGender = genderField.extra.optionList.find(
            genderOptions => genderOptions.value === familyObj.gender.defaultValue
        )
        genderField.value = selectedGender
        if (familyObj.gender.isDisable !== undefined) {
            genderField.disabled = familyObj.gender.isDisable
        }
    }

    return createNewObject(memberFieldObject)

}

const addNewMember = (memberType, formController) => {
    // member type will be FamilyMemberTypeEnum
    let familyData = familyMemberList.find((member) => member.memberType === memberType)

    let nationalMasterList = toJS(FamilyDetailsStore.nationalityList);
    let salutationMasterList = toJS(FamilyDetailsStore.salutationList);
    let lifeCoverList = toJS(FamilyDetailsStore.lifeCoverList);
    let journeyData = toJS(AuthStore.journeyData);
    let monthlyIncomeMasterList = FamilyDetailsStore.monthlyIncomelist

    let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)

    let familyMemberFieldObjectData = generateMemberEmptyDataStrucutre(
        familyData,
        lifeCoverList,
        nationalMasterList,
        salutationMasterList,
        monthlyIncomeMasterList,
        isProtectionNeedSelected
    )

    familyMemberFieldObjectData.name = familyMemberFieldObjectData.name + generateRandomString()

    formController.$("members").add(familyMemberFieldObjectData)

    if (memberType === FamilyMemberTypeEnum.CHILD || memberType === FamilyMemberTypeEnum.GRAND_CHILD) {
        formController.$("members").$(familyMemberFieldObjectData.name).$('is_member_selected').set("disabled", true)
    }

}

const selfAndSpouseGenderToggle = (formController, value, memberType, fieldName) => {

    switch (value) {
        case genderTypeEnum.MALE:
            formController.$("members").$(memberType).$(fieldName).value = genderValueEnum.FEMALE
            break;

        case genderTypeEnum.FEMALE:
            formController.$("members").$(memberType).$(fieldName).value = genderValueEnum.MALE
            break;

        default:
            break;
    }

}

const updateValue = (formController, familyMemberName, fieldName, value) => {

    let updatedValue = value

    // let NameRegEx = new RegExp("^([A-Za-z]{1,30})$")
    // Name Regex with space
    let NameRegEx = /^(?![\s-])[\A-Za-z.\s-]{1,30}$/

    if (fieldName == 'first_name' || fieldName == 'middle_name' || fieldName == 'last_name') {
        if (NameRegEx.test(updatedValue)) {
            updatedValue = updatedValue
        } else {
            updatedValue = formController.$("members").$(familyMemberName).$(fieldName).value
            if (updatedValue.length == 1) {
                updatedValue = ''
            }
        }

        if (updatedValue.length == 1) {
            updatedValue = updatedValue.toUpperCase()
        }
    }

    if(fieldName == 'dob'){

        const familyMemeberList = formController?.$('members').get()
         console.log("formController",formController.$("members").$(familyMemberName).$("life_assured").value)
        let formattedDob = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD')
        let dob = moment().diff(moment(formattedDob), 'years') < 21
         let la_selected =  formController.$("members").$(familyMemberName).$("life_assured").value

        // if (dob && la_selected) {
        //     for (let key in familyMemeberList) {
        //         formController.$("members").$(key).$('secondary_la').set("disabled", true)
        //         // updateValue(formController, foundUser?.memberType, "secondary_la", true)
        //     }
        //  }else{
        //     for (let key in familyMemeberList) {
        //         formController.$("members").$(key).$('secondary_la').set("disabled", false)
        //         // updateValue(formController, foundUser?.memberType, "secondary_la", true)
        //     }
        // }

    }

    if (fieldName === "nationality" && (value?.label === "Indian" || value?.label === "Other")) {
        formController.$("members").$(familyMemberName).$('payment_option').set("value", "")
    }


    if (fieldName == 'gender') {

        let genderValue = updatedValue.value


        formController.$("members").$(familyMemberName).$(fieldName).value = updatedValue
        if (familyMemberName == 'self' && genderValue == "Female") {
            formController.$("members").$('spouse').$('gender').value = { id: 1, label: 'Male', value: 'Male' }
        } else if (familyMemberName == 'self' && genderValue == "Male") {
            formController.$("members").$('spouse').$('gender').value = { id: 2, label: 'Female', value: 'Female' }
        }

        if (familyMemberName == 'spouse' && genderValue == "Female") {
            formController.$("members").$('self').$('gender').value = { id: 1, label: 'Male', value: 'Male' }
        } else if (familyMemberName == 'spouse' && genderValue == "Male") {
            formController.$("members").$('self').$('gender').value = { id: 2, label: 'Female', value: 'Female' }
        }

        let selfGenderValue = formController.$("members").$('self').$('gender').value.value
        let spouseGenderValue = formController.$("members").$('spouse').$('gender').value.value


        // if ((selfGenderValue && spouseGenderValue) && selfGenderValue !== spouseGenderValue) {
        //     formController.$("members").$('spouse').$(fieldName).invalidate("Self And Spouse can't have same gender")
        // } else {
        //     formController.$("members").$('spouse').$(fieldName).resetValidation()
        // }

        setSalutation(genderValue, formController, familyMemberName, selfGenderValue, spouseGenderValue)

    } else {
        formController.$("members").$(familyMemberName).$(fieldName).value = updatedValue
    }

}

const setSalutation = (gender, formController, familyMemberName) => {
    let salutationList = formController.$("members").$('spouse').$('salutation').extra.optionList

    if (familyMemberName !== 'self' && familyMemberName !== 'spouse') {

        const familyMemberGender = ['child', 'adult_child', 'grand_child']

        if (gender === "Female" && familyMemberGender.includes(familyMemberName)) {
            let salutation = salutationList.find((item) => item.label === "Ms.")
            let check = formController.$("members").$(familyMemberName).$("salutation").value
            if (check.label == "Ms." || check.label == "Mr.") {
                formController.$("members").$(familyMemberName).$("salutation").value = salutation
            }
        } else {
            let salutation = salutationList.find((item) => item.label === "Mr.")
            let check = formController.$("members").$(familyMemberName).$("salutation").value
            if (check.label == "Ms." || check.label == "Mr.") {
                formController.$("members").$(familyMemberName).$("salutation").value = salutation
            }
        }
    }
}

const validationOtherFieldMembers = (formController) => {

    let ifValid = true

    const familyMemeberList = formController.$('members').get()
    const familyMemberValueList = []

    for (let key in familyMemeberList) {

        let { first_name, last_name, dob, gender, payment_option, nationality } = familyMemeberList[key].value
        let valueObj = { memberType: key, first_name, last_name, dob, gender, payment_option, nationality }
        familyMemberValueList.push(valueObj)
    }

    familyMemberValueList.forEach((memberObj) => {

        let { memberType, first_name, last_name, dob, gender, payment_option, nationality } = memberObj

        let journeyData = toJS(AuthStore.journeyData)
        let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)

        if ((!checkIsValueEmpty(first_name) || !checkIsValueEmpty(last_name) || !checkIsValueEmpty(dob) || !checkIsValueEmpty(gender)) && (memberType != 'grand_father' || memberType != 'grand_mother')) {

            let fieldNameArray

            if (isProtectionNeedSelected) {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'gender', 'monthly_income_value']
            } else {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'gender', 'monthly_income_dropdown_option']
            }

            fieldNameArray.forEach((fieldName) => {
                if (memberType != 'grand_father' && memberType != 'grand_mother' && memberType != 'spouse') {
                    const isValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$(fieldName).value)
                    if (isValueEmpty) {
                        formController.$("members").$(memberType).$(fieldName).invalidate("This Field is mandatory")
                        ifValid = false
                    }
                    else {
                        formController.$("members").$(memberType).$(fieldName).validate()
                    }
                }
                if (memberType == 'spouse' && fieldName == 'gender') {

                    //Checking Empty Values in SPOUSE section
                    const isGenderValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$(fieldName).value)
                    const isFirstNameValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$("first_name").value)
                    const isLastNameValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$("last_name").value)
                    const isDOBValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$("dob").value)
                    let isMonthlyIncomeValueEmpty;
                    if (isProtectionNeedSelected) {
                        isMonthlyIncomeValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$("monthly_income_value").value)
                    } else {
                        isMonthlyIncomeValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$("monthly_income_dropdown_option").value)
                    }

                    // Checking if mandatory fields other than gender are empty
                    const isOtherValuesEmpty = isFirstNameValueEmpty && isLastNameValueEmpty && isDOBValueEmpty && isMonthlyIncomeValueEmpty
                    if (!isGenderValueEmpty && isOtherValuesEmpty) {
                        fieldNameArray.map((fieldName) => {
                            formController.$("members").$(memberType).$(fieldName).validate()
                        })
                    } else {
                        if (isFirstNameValueEmpty) {
                            formController.$("members").$(memberType).$("first_name").invalidate("This Field is mandatory")
                            ifValid = false
                        } else {
                            formController.$("members").$('spouse').$("first_name").resetValidation()
                            //ifValid = true
                        }
                        if (isLastNameValueEmpty) {
                            formController.$("members").$(memberType).$("last_name").invalidate("This Field is mandatory")
                            ifValid = false
                        } else {
                            formController.$("members").$('spouse').$("last_name").resetValidation()
                            //ifValid = true
                        }
                        if (isDOBValueEmpty) {
                            formController.$("members").$(memberType).$("dob").invalidate("This Field is mandatory")
                            ifValid = false
                        } else {
                            formController.$("members").$('spouse').$("dob").resetValidation()
                            // ifValid = true
                        }
                        if (isMonthlyIncomeValueEmpty) {
                            formController.$("members").$(memberType).$(fieldNameArray[fieldNameArray.length - 1]).invalidate("This Field is mandatory")
                            ifValid = false
                        } else {
                            formController.$("members").$('spouse').$(fieldNameArray[fieldNameArray.length - 1]).resetValidation()
                            // ifValid = true
                        }
                    }
                }
            })
        }
        if ((!checkIsValueEmpty(first_name) || !checkIsValueEmpty(last_name) || !checkIsValueEmpty(dob)) && (memberType === 'grand_father' || memberType === 'grand_mother')) {

            let fieldNameArray

            if (isProtectionNeedSelected) {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'monthly_income_value']
            } else {
                fieldNameArray = ['first_name', 'last_name', 'dob', 'monthly_income_dropdown_option']
            }

            fieldNameArray.forEach((fieldName) => {
                if (memberType === 'grand_father' || memberType === 'grand_mother') {
                    const isValueEmpty = checkIsValueEmpty(formController.$("members").$(memberType).$(fieldName).value)
                    if (isValueEmpty) {
                        formController.$("members").$(memberType).$(fieldName).invalidate("This Field is mandatory")
                        ifValid = false
                    }
                    else {
                        formController.$("members").$(memberType).$(fieldName).validate()
                    }
                }

            })
        }

        if ((!checkIsValueEmpty(first_name) && !checkIsValueEmpty(last_name) && !checkIsValueEmpty(dob) && !checkIsValueEmpty(gender)) && checkIsValueEmpty(payment_option) && ACCEPT_NATIONALITY.includes(nationality.label)) {
            formController.$("members").$(memberType).$('payment_option').invalidate("This Field is mandatory")
            ifValid = false
        } else {
            formController.$("members").$(memberType).$('payment_option').validate()
        }
    })

    return ifValid
}

const getEligibleProposerList = async (memberDetails, formController, journeyData) => {
    if (memberDetails[1].value.id) {
        global.loading(true);
        let source_system = getCookieValue("source")
        let selectedNeedId = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 4)
        if (!selectedNeedId) {
            selectedNeedId = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need !== 4)
        }
        const proposerListResponse = await axios.post(APITypes.GET_ELIGIBLE_PROPOSER_LIST, {
            journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
            need_id: selectedNeedId.need,
            family_member_id: memberDetails[1].value.id,
        });
        let familyData = Object.entries(formController.$("members").get())
        let selectedPr = familyData.find((item) => item[1].value.proposer)

        if (proposerListResponse?.status?.toLowerCase() === "success" && source_system != BANCA_JOURNEY) {

            let isProtectionNeedSelected = checkIsProtectionNeedSelected(journeyData.family_product_details_list)
            let alreadySelectedPr = false
            if (selectedPr) {
                alreadySelectedPr = proposerListResponse?.data?.some((item) => item?.family_member_type.toLowerCase() === selectedPr[0])
            }
            familyData.forEach((data) => {
                let isEligibleMember = proposerListResponse.data.some((item) => item.family_member_type.toLowerCase() === data[0])
                if (!isEligibleMember) {
                    if (alreadySelectedPr && selectedPr[0] !== data[0]) {
                        updateValue(formController, data[0], "proposer", false)
                    } else if (!alreadySelectedPr) {
                        updateValue(formController, data[0], "proposer", false)
                        updateValue(formController, proposerListResponse.data[0].family_member_type.toLowerCase(), "proposer", true)
                    }
                    if (!isProtectionNeedSelected) {
                        formController.$("members").$(data[0]).$("proposer").set("disabled", true)
                    }
                } else {
                    if (!isProtectionNeedSelected) {
                        formController.$("members").$(data[0]).$("proposer").set("disabled", false)
                    }
                }
            })
        } else if (source_system == BANCA_JOURNEY) {
            familyData.forEach((data) => {
                // if (data[0] !== selectedPr[0]) {
                formController.$("members").$(data[0]).$("proposer").set("disabled", true)
                // }
            })
        }
        global.loading(false);
    }
}

const checkIsMemberFieldSelected = (formController, checkDonebutton) => {

    const familyMemeberList = formController?.$('members').get()
    const familyMemberValueList = []
    let isselect = false

    for (let key in familyMemeberList) {
        let { first_name, last_name, dob, gender } = familyMemeberList[key].value
        let valueObj = { memberType: key, first_name, last_name, dob, gender }
        familyMemberValueList.push(valueObj)
    }
    familyMemberValueList.forEach((member) => {
        let { memberType } = member
        function areAllValuesNotEmpty(memberField) {
            let allFieldNotEmpty = true;

            function checkValue(value) {
                if (typeof value === 'string') {
                    if (value?.trim() === '') {
                        allFieldNotEmpty = false;
                    }
                } else if (Array.isArray(value)) {
                    value.forEach(item => checkValue(item));
                } else if (typeof value === 'object' && value !== null) {
                    Object.values(value).forEach(nestedValue => checkValue(nestedValue));
                }
            }

            checkValue(memberField);

            return allFieldNotEmpty;
        }

        const result = areAllValuesNotEmpty(member);

        if (result) {

            let memberIsDisabled = formController.$("members").$(memberType).$('is_member_selected').disabled
            let memberSelected = formController.$("members").$(memberType).$('is_member_selected').value

            if (!memberSelected && memberIsDisabled) {
                updateValue(formController, memberType, 'is_member_selected', true)
            }
            formController.$("members").$(memberType).$('is_member_selected').set("disabled", false)
            isselect = true;
        }
        else {
            formController.$("members").$(memberType).$('is_member_selected').set("disabled", true)
        }
    })
    return isselect;
}

const setSecondaryLa = (formController) => {
    const familyMemeberList = formController?.$('members').get()
    const familyMemberValueList = []
    if (!isObjectEmpty(familyMemeberList)) {
        for (let key in familyMemeberList) {
            let { dob } = familyMemeberList[key].value
            const today = moment();
            const birthdateMoment = moment(dob);
            const age = today.diff(birthdateMoment, 'years');

            let valueObj = { memberType: key, age: age }
            familyMemberValueList.push(valueObj)
        }
        const foundUser = familyMemberValueList.find(user => user.age <= 18);
        if (foundUser) {
            updateValue(formController, foundUser?.memberType, "secondary_la", true)
        }
    }
}

const checkMemberTypeEmpty = (familyDetailsList, addMemberType) => {
    let updatedfamilyDetailsList = familyDetailsList.map(item => ({
        ...item,
        family_member_type: item?.family_member_type === null ? addMemberType : item?.family_member_type
    }));
    return updatedfamilyDetailsList
}

const updateMemberType = (formController, memberType) => {
    let familyDetailsList = toJS(AuthStore.journeyData.family_details_list)
    let journeyData = toJS(AuthStore.journeyData)

    let updatedfamilyDetailsList = familyDetailsList.map(item => ({
        ...item,
        family_member_type: item?.family_member_type === null ? memberType?.id : item?.family_member_type
    }));
    journeyData["family_details_list"] = updatedfamilyDetailsList

    reInitializeFamilyMemberData(journeyData, formController)

    formController.$("members").$(memberType?.id.toLowerCase()).$('member_type_list').set("value", memberType)
    formController.$("show_member_type").set("value", memberType)
    let memberDOB = formController?.$("members")?.$(memberType?.id.toLowerCase())?.$('dob')?.value
    const birthDate = moment(memberDOB);
    const currentDate = moment()
    const age = currentDate.diff(birthDate, 'years');

    if (memberType.id === FamilyMemberTypeEnum.GRAND_CHILD && age > 18) {
        formController?.$("members")?.$(memberType?.id.toLowerCase())?.$('dob').invalidate("Please enter the age less than 18 years")
    } else if (memberType.id !== FamilyMemberTypeEnum.GRAND_CHILD && memberType.id !== FamilyMemberTypeEnum.CHILD && age <= 18) {
        formController?.$("members")?.$(memberType?.id.toLowerCase())?.$('dob').invalidate("Please enter the age more than 18 years")
    }
    let salutationList = formController.$("members").$(memberType?.id.toLowerCase()).$('salutation').extra.optionList
    let genderList = formController.$("members").$(memberType?.id.toLowerCase()).$('gender').extra.optionList

    if (memberType.id === FamilyMemberTypeEnum.SPOUSE || memberType.id === FamilyMemberTypeEnum.GRAND_MOTHER) {
        formController.$("members").$(memberType?.id.toLowerCase()).$('salutation').set("value", salutationList[2])
        formController.$("members").$(memberType?.id.toLowerCase()).$('gender').set("value", genderList[1])
    }
    if (memberType.id === FamilyMemberTypeEnum.GRAND_FATHER) {
        formController.$("members").$(memberType?.id.toLowerCase()).$('salutation').set("value", salutationList[0])
        formController.$("members").$(memberType?.id.toLowerCase()).$('gender').set("value", genderList[0])
    }

    if(memberType.id === FamilyMemberTypeEnum.GRAND_FATHER || memberType.id === FamilyMemberTypeEnum.GRAND_MOTHER){
        formController.$("members").$(memberType?.id.toLowerCase()).$('life_assured').set("value", true)
        formController.$("members").$(memberType?.id.toLowerCase()).$('proposer').set("value", true)
        formController.$("members").$("self").$('proposer').set("disabled", true)
    }else{
        formController.$("members").$(memberType?.id.toLowerCase()).$('life_assured').set("value", true)
        formController.$("members").$("self").$('proposer').set("value", true)
    }

    // formController.$("members").$(memberType?.id.toLowerCase()).$('life_assured').set("value", true)
    // formController.$("members").$("self").$('proposer').set("value", true)
}

const checkExistingCustomerdetails = (formController) => {
    let check = false
    let formData = formController?.values()
    let journeyData = toJS(AuthStore?.journeyData)
    let memberTypeEmpty = journeyData?.family_details_list.find(item => item?.family_member_type === null)
    if(!isObjectEmpty(formData?.show_member_type)){
        let selectedMemberdetails = formController.$("members").$(formData?.show_member_type?.id.toLowerCase())?.value
        if (selectedMemberdetails?.first_name === memberTypeEmpty?.first_name &&
            selectedMemberdetails?.last_name === memberTypeEmpty?.last_name &&
            selectedMemberdetails?.dob === memberTypeEmpty?.dob &&
            selectedMemberdetails?.gender?.value === memberTypeEmpty?.gender &&
            selectedMemberdetails?.salutation?.id === memberTypeEmpty?.salutation &&
            selectedMemberdetails?.nationality?.id === memberTypeEmpty?.nationality
        ) {
            check = true
        }
    }
    return check
}


export { addFamilyMember, generateMemberEmptyDataStrucutre, addNewMember, preFillUserFields, sendDataToServer, closeModal, updateValue, selfAndSpouseGenderToggle, toggleDisableOptions, changeFieldValue, validationOtherFieldMembers, checkIsProtectionNeedSelected, getEligibleProposerList, checkIsMemberFieldSelected, setSecondaryLa, checkIsNotProtectionNeedSelected, checkMemberTypeEmpty, updateMemberType ,checkExistingCustomerdetails}


